import { render, staticRenderFns } from "./Rec2Viewer.vue?vue&type=template&id=a8978176&scoped=true&"
import script from "./Rec2Viewer.vue?vue&type=script&lang=ts&"
export * from "./Rec2Viewer.vue?vue&type=script&lang=ts&"
import style0 from "./Rec2Viewer.vue?vue&type=style&index=0&id=a8978176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8978176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
